import { useCallback, useMemo } from 'react';
import type { FilterBound, FilterValueSetState } from './types';
import { useFilters } from './widget-filters-provider';

export function useBindFilter<T>(filterName: string): FilterBound<T> {
  const {
    getFilterValue,
    setFilterValue,
    setAppliedFilterValue,
    getAppliedFilterValue
  } = useFilters();

  const selectedValue = useMemo(
    () => getFilterValue<T>(filterName),
    [filterName, getFilterValue]
  );

  const appliedValue = useMemo(
    () => getAppliedFilterValue<T>(filterName),
    [filterName, getAppliedFilterValue]
  );

  const setSelected = useCallback(
    (nextValue: FilterValueSetState<T>) => {
      setFilterValue<T>(filterName, (prev: T) => nextValue(prev));
    },
    [filterName, setFilterValue]
  );

  const setApplied = useCallback(
    (nextValue: FilterValueSetState<T>) => {
      setAppliedFilterValue<T>(filterName, (prev: T) => nextValue(prev));
    },
    [filterName, setAppliedFilterValue]
  );

  return {
    name: filterName,
    selectedValue,
    appliedValue,
    setSelected,
    setApplied
  };
}
